import React, { useCallback, useState } from "react";
import {
  Modal,
  Box,
  Typography,
  Tooltip,
  IconButton,
  Button,
  TextField,
  CircularProgress,
  Stack,
} from "@mui/material";
import { Edit } from "@mui/icons-material";
import { postJsonData } from "../../network/ApiController";
import ApiEndpoints from "../../network/ApiEndPoints";
import {
  apiErrorToast,
  okSuccessToast,
  okSuccessToastsm,
} from "../../utils/ToastUtil";
import ModalHeader from "../../modals/ModalHeader";
import Loader from "../../component/loading-screen/Loader";
import ModalFooter from "../../modals/ModalFooter";

import DeleteIcon from "@mui/icons-material/Delete";
import Spinner from "../../component/loading-screen/Spinner";

const DeleteTask = ({ data, getTasks, disabled }) => {
  const [open, setOpen] = useState(false);
  const [updaLoading, setUpdateLoading] = useState(false);

  const [formData, setFormData] = useState({
    id: data.id,
    project_id: data.project_id,
    category: data.category,
    start_date: data.start_date,
    end_date: data.end_date,
    assigned_to: data.assigned_to,
    priority: data.priority,
    description: data.description,
    status: data.status,
  });

  const handleOpen = () => {
    setFormData({
      id: data.id,
      project_id: data.project_id,
      category: data.category,
      start_date: data.start_date,
      end_date: data.end_date,
      assigned_to: data.assigned_to, // Fixed typo
      priority: data.priority,
      description: data.description,
      status: data.status,
    });
    setOpen(true);
  };

  const handleClose = () => setOpen(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const deleteUser = useCallback(async () => {
    setUpdateLoading(true);
    postJsonData(
      `${ApiEndpoints.DELETE_TASK}/${formData.id}`,
      formData,
      setUpdateLoading,
      (res) => {
        okSuccessToast(res.data.message);
        setUpdateLoading(false);
        setOpen(false);
        getTasks();
      },
      (error) => {
        apiErrorToast(error);
        setOpen(false);
      }
    );
  }, [data.id, formData, getTasks]);

  const handleSubmit = (e) => {
    e.preventDefault();
    deleteUser();
  };

  return (
    <>
      <Tooltip title="Delete Task">
        <IconButton
          sx={{ color: "rgb(228, 36, 36)" }}
          onClick={handleOpen}
          disabled={disabled} // Disable based on role and filter
        >
          <DeleteIcon />
        </IconButton>
      </Tooltip>

      <Modal open={open} onClose={handleClose}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 400,
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
            borderRadius: 2,
            textAlign: "center",
          }}
        >
            <Spinner loading={updaLoading} />
          <ModalHeader
            title="Delete Task"
            handleClose={handleClose}
            subtitle="Easily  Delete Task"
          />
          <Typography
            id="delete-confirmation-modal"
            variant="h6"
            fontWeight="bold"
          >
            Are you sure you want to delete this task ?
          </Typography>
          <Box>
            <ModalFooter
              form="delete-task"
              request={updaLoading}
              btn="Delete Task"
              onClick={handleSubmit}
            />
          </Box>
        </Box>
      </Modal>
    </>
  );
};

export default DeleteTask;
